import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=2f28e83b&scoped=true&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleModal.vue?vue&type=style&index=0&id=2f28e83b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28e83b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f28e83b', component.options)
    } else {
      api.reload('2f28e83b', component.options)
    }
    module.hot.accept("./VerDetalleModal.vue?vue&type=template&id=2f28e83b&scoped=true&", function () {
      api.rerender('2f28e83b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/AsignacionMultiFlota/VerDetalleModal.vue"
export default component.exports